module.exports = __webpack_public_path__ + "img/shipo-icon-weather-cloudy.2dae5893.svg";